import React from 'react';
import './VersionBadge.css';

export const VersionBadge: React.FC = () => {
  return (
    <span className='version-badge' aria-hidden='true'>
      Signal Viewer App v{__APP_VERSION__}
    </span>
  );
};
